import { useId, useRef } from 'react'
import type { JSX } from 'react'

import { Slot } from '@buffer-mono/popcorn'

type FileInputProps = React.ComponentPropsWithoutRef<'input'>

export const FileInput = ({
  children,
  ...props
}: FileInputProps): JSX.Element => {
  const inputRef = useRef<HTMLInputElement>(null)
  const inputId = useId()

  const handleClick = (): void => {
    if (inputRef.current) {
      inputRef.current.click()
    }
  }

  const handleInputOnChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    props.onChange?.(event)
    // Reset the input value to allow uploading the same file again
    if (inputRef.current) {
      inputRef.current.value = ''
    }
  }

  return (
    <Slot.Root onClick={handleClick}>
      <Slot.Slottable>{children}</Slot.Slottable>
      <input
        id={inputId}
        name="file-upload-input"
        type="file"
        hidden
        ref={inputRef}
        {...props}
        onChange={handleInputOnChange}
      />
    </Slot.Root>
  )
}
